'use strict';

const processInclude = require('BASE/util');

if ($('#remote-include-container.js-remote-include.departure-list').length) {
    $.ajax($('#remote-include-container.js-remote-include').attr('data-url')).done(function(data) {
        $('#remote-include-container.js-remote-include').html(data);
        processInclude(require('../plp_lp'));
    });
}